import { Flex } from "@redotech/redo-web/flex";
import { ArbiterIconSvg } from "@redotech/redo-web/icon";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export interface NotFoundProps {
  icon: ArbiterIconSvg;
  text: string;
  description: string;
}

export const NotFound = memo(function NotFound({
  icon: IconComponent,
  text,
  description,
}: NotFoundProps) {
  return (
    <Flex
      align="center"
      borderColor="primary"
      borderStyle="solid"
      borderWidth="1px"
      dir="column"
      fontFamily="text"
      gap="md"
      justify="center"
      p="xl"
      radius="md"
      w="full"
    >
      <IconComponent
        style={{
          color: "var(--darker-brand-color-on-lightMode)",
          width: "24px",
          height: "24px",
        }}
      />
      <Text
        fontSize="sm"
        fontWeight="medium"
        textAlign="center"
        textColor="primary"
      >
        {text}
      </Text>
      <Text fontSize="xs" textAlign="center" textColor="secondary">
        {description}
      </Text>
    </Flex>
  );
});
